import * as tslib_1 from "tslib";
import { Vue, Component, Prop } from 'vue-property-decorator';
let Report = class Report extends Vue {
};
tslib_1.__decorate([
    Prop({ default: {} })
], Report.prototype, "assistant", void 0);
tslib_1.__decorate([
    Prop()
], Report.prototype, "close", void 0);
Report = tslib_1.__decorate([
    Component({})
], Report);
export default Report;
